import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';

import Wrapper from './Wrapper';

const Content = ({ children, className, css }) => {
  const contentCls = cn('cr-layout__content', className);
  return (
    <Wrapper className={contentCls} css={css}>
      <div className="cr-width-full">{children}</div>
    </Wrapper>
  );
};

Content.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  css: PropTypes.shape(),
};

export default Content;
